import { render, staticRenderFns } from "./ActivityConfigManager.vue?vue&type=template&id=5f25c99a&scoped=true"
import script from "./ActivityConfigManager.vue?vue&type=script&lang=js"
export * from "./ActivityConfigManager.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigManager.vue?vue&type=style&index=0&id=5f25c99a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25c99a",
  null
  
)

export default component.exports